import { __ } from '@wordpress/i18n';
export var ALIGNMENT_LABEL = {
  'top left': __('Top Left'),
  'top center': __('Top Center'),
  'top right': __('Top Right'),
  'center left': __('Center Left'),
  'center center': __('Center Center'),
  'center right': __('Center Right'),
  'bottom left': __('Bottom Left'),
  'bottom center': __('Bottom Center'),
  'bottom right': __('Bottom Right')
};
export var GRID = [['top left', 'top center', 'top right'], ['center left', 'center center', 'center right'], ['bottom left', 'bottom center', 'bottom right']];